import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import UsersPage from "./index";
import UserEditPage from "./userEdit";
 

export default (
  <Route path="users">
    <Route
      index
      element={
        <Protected
          path="/admin/users"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <UsersPage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/users/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <UserEditPage />
        </Protected>
      }
    />  
  </Route>
);



